/**
 * Componente PrivacySection
 * Wrapper para la política de privacidad
 */
import React from "react";
import { useNavigate } from "react-router-dom";
import MotionWrapper from "../../shared/components/MotionWrapper";
import PrivacyPolicy from "./PrivacyPolicy";

const PrivacySection = () => {
    const navigate = useNavigate();

    return (
        <MotionWrapper sectionKey="privacidad">
            <PrivacyPolicy onBack={() => navigate(-1)} />
        </MotionWrapper>
    );
};

export default PrivacySection;
